import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import { Box, Typography } from '@material-ui/core';
import { useTreatmentIntroStyles } from './styles/styles';
import QuestionTitle from '../QuestionTitle';

export const QuestionIntro = ({ question }) => {
  const classes = useTreatmentIntroStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.root}>
      <QuestionTitle label={question.title} />
      {question.options.map((option, i) => (
        <Typography key={option.iconText} variant="subtitle1" className={classes.label}>
          {i + 1}.&nbsp;{t(option.label)}
        </Typography>
      ))}
    </Box>
  );
};

QuestionIntro.propTypes = {
  question: PropTypes.object.isRequired,
};
